import React, { createContext } from "react";

// export const userContext = createContext("none");
export const userContext = createContext({
    user_id:'',
    logout: () => {},
});

